import { Button } from './ui/button'
import { ArrowRight } from 'lucide-react'
import { Suspense, lazy } from 'react'
import { useSmoothScroll } from '@/hooks/useSmoothScroll' // Corrected import path
import { motion } from 'framer-motion'
const Hero3D = lazy(() => import('./Hero3D'))

export default function Hero() {
  const { handleNavClick } = useSmoothScroll()

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background gradient */}
      <div
        className="absolute inset-0 opacity-60 bg-hero-gradient"
      />
      
      {/* Hero 3D Objects */}
      <div className="absolute inset-0 pointer-events-none opacity-80">
        <Suspense fallback={null}>
          <Hero3D />
        </Suspense>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-5xl mx-auto px-6">
        <motion.h1
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 tracking-tight"
        >
          Vi skaper <br/>
          <span className="gradient-text">Digitale Opplevelser</span>
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-xl md:text-2xl text-muted-foreground mb-10 max-w-2xl mx-auto"
        >
          Vi bygger løsninger som skalerer, Pyksel for Pyksel.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Button
            size="lg"
            className="group px-8 py-4 text-lg hero-glow smooth-transition hover:scale-105"
            onClick={() => handleNavClick('arbeid')}
          >
            Se vårt arbeid
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
          
          <Button
            variant="secondary"
            size="lg"
            className="group px-8 py-4 text-lg smooth-transition hover:scale-105"
            onClick={() => handleNavClick('contact')}
          >
            Kontakt oss
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-muted-foreground rounded-full flex justify-center">
          <div className="w-1 h-2 bg-muted-foreground rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  )
}
